import React from "react";
import Request from "../Admin/Request";

const Home = () => {
  return <Request />;
};
export default Home;
